import React from 'react';

const TemplateCard = ({ template, onEdit, onUse }) => {
    const variableCount = template.variables?.length || 0;
    const clauseCount = template.blocks?.filter((b) => b.type === 'clause').length || 0;
    const updatedAt = template.updatedAt
        ? new Date(template.updatedAt).toLocaleDateString('en-IN', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
        })
        : null;

    return (
        <div className="template-card">
            <div className="template-card-header">
                <h3 className="template-card-title">{template.title || 'Untitled'}</h3>
                <span className={`template-card-status ${template.status || 'draft'}`}>
                    {template.status || 'Draft'}
                </span>
            </div>

            <div className="template-card-meta">
                {template.subcategory} • {template.jurisdiction || 'India'}
                {updatedAt && ` • ${updatedAt}`}
            </div>

            {template.tags?.length > 0 && (
                <div className="template-card-tags">
                    {template.tags.slice(0, 3).map((tag) => (
                        <span key={tag} className="template-tag">
                            {tag}
                        </span>
                    ))}
                    {template.tags.length > 3 && (
                        <span className="template-tag">+{template.tags.length - 3}</span>
                    )}
                </div>
            )}

            <div className="template-card-stats">
                <span>{variableCount} variable{variableCount !== 1 ? 's' : ''}</span>
                <span>{clauseCount} clause{clauseCount !== 1 ? 's' : ''}</span>
            </div>

            <div className="template-card-actions">
                <button className="template-btn primary" onClick={onUse}>
                    Use
                </button>
                <button className="template-btn secondary" onClick={onEdit}>
                    Edit
                </button>
            </div>
        </div>
    );
};

export default TemplateCard;
